const globalSyncMiddleware = store => next => action => {
    const [, sliceName, reducerName] = action.type.split('/')

    /*if (reducerName === 'updateSearchParams') {
        if(action.payload.searchBy){
            const updatedParams = {
                searchBy: action.payload.searchBy,
                searchText: action.payload.searchText
            }
            store.dispatch({type: `global/updateSearchParams`, payload: updatedParams})
        }
    }*/

    /*if (reducerName === 'updateSearchParams') {
        if(action.payload.searchBy !== "all"){
            const updatedParams = {
                searchBy: action.payload.searchBy,
                searchText: action.payload.searchText
            }

            const slicesToSync = [
                "getVendorPaymentsPettyCash",
                "getVendorPaymentsNonCredit",
                "getVendorPaymentsCheques",
                "getSellerPOVendorPayments",
                "sellerSearchData",
                "getSellerDebitNotes",
                "getRequirement",
                "PettyCashAccounts",
                "PettyCash",
                "getListUser",
                "getInvoiceBooking",
                "getInward",
                "getFollowUpItems",
                "getSellerPOs",
                "companyList",
                "getBuyerPOs",
                "getAdjustmentNotes",
                "approvalList",
                "getBuyerInvoice"
            ]

            slicesToSync
                .filter(slice => slice !== sliceName) 
                .forEach(slice => {
                    store.dispatch({
                        type: `user/${slice}/updateSearchByParam`,
                        payload: updatedParams
                    })
                })
        }
    }*/

    return next(action)
}

export default globalSyncMiddleware